import {
  Button,
  Container,
  CssBaseline,
  TextField,
  Typography,
  Box,
  IconButton,
  InputAdornment
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import useStyles from "components/Auth/Register/RegisterStyles";
import React, { useEffect, useState } from "react";
import { checkEmailValid, checkFieldValid } from "components/User/Validation";
import useActions from "../actions";
import { useSelector } from "react-redux";
import { USER_PROP } from "components/User/constants";
import PasswordField from "components/common/PasswordField";
import { useHistory } from "react-router";
import VerifyPasswordField from "components/common/VerifyPasswordField";

const PasswordChange = () => {
  const classes = useStyles();

  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showVerifyPassword, setShowVerifyPassword] = useState(false);

  const [isFormValid, setIsFormValid] = useState(true);
  const [fieldChecked, setFieldChecked] = useState(false);
  const { requestResetPassword, resetPasswordWithToken } = useActions();
  const { location } = useSelector((state) => state.router);
  const hasToken = !!location.query.token;

  const submitForm = (event) => {
    event.preventDefault();
    if (hasToken) {
      resetPasswordWithToken(password, history);
    } else {
      requestResetPassword(email);
    }
  };

  useEffect(() => {
    checkFormValidity();
  });

  const checkFormValidity = () => {
    if (hasToken) {
      let checkFields = password && verifyPassword;
      checkFields = password === verifyPassword && checkFields;
      setIsFormValid(checkFieldValid(USER_PROP.PASSWORD, password) && checkFields);
    } else {
      setIsFormValid(checkEmailValid(email));
    }
  };

  const isPasswordMatching = () => {
    return checkPwdEmpty() && password === verifyPassword;
  };

  const onClickPassword = function (e) {
    setPassword(e.target.value);
  };
  const onClickVerifyPassword = function (e) {
    setVerifyPassword(e.target.value);
  };

  const onClickNewPwd = function () {
    setFieldChecked(true);
  };
  const setEmailAdd = function (e) {
    setEmail(e.target.value);
  };
  const onCLickEmail = function () {
    setFieldChecked(true);
  };
  const checkPwdEmpty = () => {
    return password !== "" && verifyPassword !== "";
  };
  const getHelperText = () => {
    return fieldChecked.verifyPassword
      ? !isPasswordMatching()
        ? checkPwdEmpty()
          ? "Passwords do not match"
          : "Password Cannot be empty"
        : "Passwords match"
      : "";
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const toggleShowVerifyPassword = () => {
    setShowVerifyPassword(!showVerifyPassword);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          {hasToken ? "Set New Password" : "Reset Password"}
        </Typography>
        <form className={classes.form} onSubmit={submitForm} noValidate>
          {!hasToken ? (
            <TextField
              variant="outlined"
              margin="normal"
              size="small"
              required
              fullWidth
              label="Email Address"
              name="email"
              autoComplete="email"
              error={fieldChecked && !checkEmailValid(email)}
              onClick={onCLickEmail}
              value={email}
              onChange={setEmailAdd}
              autoFocus
            />
          ) : (
            <Box>
              <PasswordField
                variant="outlined"
                margin="normal"
                size="small"
                required
                fullWidth
                label="New Password"
                name="password"
                autoComplete="password"
                error={
                  fieldChecked && !checkFieldValid(USER_PROP.PASSWORD, password)
                }
                onClick={onClickNewPwd}
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={onClickPassword}
                autoFocus
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={toggleShowPassword}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                verfiyPasswordFieldName={false}
              />
              <VerifyPasswordField
                variant="outlined"
                margin="normal"
                size="small"
                required
                fullWidth
                label="Verify Password"
                name="verifyPassword"
                autoComplete="password"
                error={fieldChecked && !isPasswordMatching()}
                helperText={getHelperText()}
                onClick={onClickNewPwd}
                type={showVerifyPassword ? "text" : "password"}
                value={verifyPassword}
                onChange={onClickVerifyPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={toggleShowVerifyPassword}
                        edge="end"
                      >
                        {showVerifyPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                verfiyPasswordFieldName={fieldChecked && !isPasswordMatching()}
              />
            </Box>
          )}

          <Button
            type="submit"
            fullWidth
            disabled={!isFormValid}
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            {hasToken ? "Set Password" : "Reset Password"}
          </Button>
        </form>
      </div>
    </Container>
  );
};

export default PasswordChange;
